import cx from 'classnames';
import * as React from 'react';
import TextareaAutosize, { TextareaAutosizeProps } from 'react-textarea-autosize';
import { callAll } from '../helper/fp';
import { isFunction } from '../helper/typeguard';

export type TextaraProps = {
  /**
   * callback that will be invoked with the new value when value is changed.
   */
  onChangeValue?: (value: string) => void;
} & Omit<TextareaAutosizeProps, 'ref' | 'inputRef' | 'label'>;
/**
 * Textarea is a wrapper around [`react-textarea-autosize`](https://github.com/andreypopp/react-textarea-autosize) component,
 * thus it would accepts all props a `<textarea />` accepts in addition
 * of `onChangeValue` props, except `inputRef` props.
 * Use `ref` to access the underlying `<textarea />` element instead
 */
export const Textarea = React.forwardRef<HTMLTextAreaElement, TextaraProps>(function TextareaComp(
  { className, onChangeValue, onChange, ...props },
  ref
) {
  return (
    <TextareaAutosize
      className={cx('form-control', className)}
      onChange={callAll(onChange, onChangeValue && ((ev) => onChangeValue(ev.target.value)))}
      inputRef={(node) => {
        if (ref) {
          if (isFunction(ref)) {
            ref(node);
          } else {
            (ref as React.MutableRefObject<HTMLTextAreaElement>).current = node;
          }
        }
      }}
      {...props}
    />
  );
});
